'use strict';

var cov_2p8b3j5xhg = function () {
  var path = 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\routes.js',
      hash = 'c96fc83cc5e3ac34d584475af16b03c0de74e6b9',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\routes.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 32,
          column: 24
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 81
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 74
        }
      },
      '3': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 118
        }
      },
      '4': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 107
        }
      },
      '5': {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 13,
          column: 7
        }
      },
      '6': {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 22
        }
      },
      '7': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 23,
          column: 6
        }
      },
      '8': {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 20,
          column: 9
        }
      },
      '9': {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 30,
          column: 7
        }
      },
      '10': {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 29,
          column: 9
        }
      },
      '11': {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 44
        }
      },
      '12': {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 49
        }
      },
      '13': {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 50
        }
      },
      '14': {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 52
        }
      },
      '15': {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 36
        }
      },
      '16': {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 110,
          column: 7
        }
      },
      '17': {
        start: {
          line: 85,
          column: 26
        },
        end: {
          line: 88,
          column: 11
        }
      },
      '18': {
        start: {
          line: 89,
          column: 25
        },
        end: {
          line: 92,
          column: 11
        }
      },
      '19': {
        start: {
          line: 93,
          column: 10
        },
        end: {
          line: 95,
          column: 13
        }
      },
      '20': {
        start: {
          line: 94,
          column: 12
        },
        end: {
          line: 94,
          column: 32
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 7
          },
          end: {
            line: 3,
            column: 8
          }
        },
        loc: {
          start: {
            line: 3,
            column: 111
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 3
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 11,
            column: 45
          },
          end: {
            line: 11,
            column: 46
          }
        },
        loc: {
          start: {
            line: 11,
            column: 51
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 11
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 15,
            column: 28
          },
          end: {
            line: 15,
            column: 29
          }
        },
        loc: {
          start: {
            line: 15,
            column: 37
          },
          end: {
            line: 21,
            column: 7
          }
        },
        line: 15
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 24,
            column: 47
          },
          end: {
            line: 24,
            column: 48
          }
        },
        loc: {
          start: {
            line: 24,
            column: 53
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 24
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 25,
            column: 49
          },
          end: {
            line: 25,
            column: 50
          }
        },
        loc: {
          start: {
            line: 25,
            column: 60
          },
          end: {
            line: 29,
            column: 7
          }
        },
        line: 25
      },
      '5': {
        name: 'routesConfig',
        decl: {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 35,
            column: 21
          }
        },
        loc: {
          start: {
            line: 35,
            column: 77
          },
          end: {
            line: 112,
            column: 1
          }
        },
        line: 35
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 84,
            column: 68
          },
          end: {
            line: 84,
            column: 69
          }
        },
        loc: {
          start: {
            line: 84,
            column: 119
          },
          end: {
            line: 96,
            column: 9
          }
        },
        line: 84
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 93,
            column: 90
          },
          end: {
            line: 93,
            column: 91
          }
        },
        loc: {
          start: {
            line: 93,
            column: 101
          },
          end: {
            line: 95,
            column: 11
          }
        },
        line: 93
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 20,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 20,
            column: 9
          }
        }, {
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 20,
            column: 9
          }
        }],
        line: 16
      },
      '1': {
        loc: {
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 16,
            column: 99
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 16,
            column: 55
          }
        }, {
          start: {
            line: 16,
            column: 59
          },
          end: {
            line: 16,
            column: 99
          }
        }],
        line: 16
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_2p8b3j5xhg.s[0];
angular.module('app').run(function (cfCryptoHttpInterceptor, $rootScope, $state, $anchorScroll, $transitions, $http, myVars, $location) {
  ++cov_2p8b3j5xhg.f[0];
  ++cov_2p8b3j5xhg.s[1];

  $rootScope.base64Key = CryptoJS.enc.Base64.parse('51oc7lWGNg/W2Rs7CGUdCQ==');
  ++cov_2p8b3j5xhg.s[2];
  $rootScope.iv = CryptoJS.enc.Base64.parse('o/U1KF39hmtaui8/B+kP8w==');
  //$rootScope.apiOpen = 'http://125.212.225.149:8600/rest/open/';

  ++cov_2p8b3j5xhg.s[3];
  $rootScope.apiOpen = $location.protocol() + '://' + $location.host() + ':' + $location.port() + '/api/rest/open/';
  ++cov_2p8b3j5xhg.s[4];
  $rootScope.apiUrl = $location.protocol() + '://' + $location.host() + ':' + $location.port() + '/api/';
  // $rootScope.apiOpen = 'http://localhost:6500/rest/open/';
  ++cov_2p8b3j5xhg.s[5];
  $rootScope.$on('$locationChangeSuccess', function () {
    ++cov_2p8b3j5xhg.f[1];
    ++cov_2p8b3j5xhg.s[6];

    $anchorScroll();
  });
  ++cov_2p8b3j5xhg.s[7];
  $transitions.onSuccess({ to: '*', from: '*' }, function (trans) {
    ++cov_2p8b3j5xhg.f[2];
    ++cov_2p8b3j5xhg.s[8];

    if ((++cov_2p8b3j5xhg.b[1][0], angular.equals(trans.$to().name, 'chitiet')) || (++cov_2p8b3j5xhg.b[1][1], angular.equals(trans.$to().name, 'view'))) {
      // PageViews.add(trans.$to().name);
      // PageViews.add('views');
      // $rootScope.pageViews = PageViews.get(trans.$to().name);

      ++cov_2p8b3j5xhg.b[0][0];
    } else {
      ++cov_2p8b3j5xhg.b[0][1];
    }
  });
  ++cov_2p8b3j5xhg.s[9];
  $transitions.onStart({ to: '*', from: '*' }, function () {
    ++cov_2p8b3j5xhg.f[3];
    ++cov_2p8b3j5xhg.s[10];

    return $http.post($rootScope.apiOpen).then(function (results) {
      ++cov_2p8b3j5xhg.f[4];
      ++cov_2p8b3j5xhg.s[11];

      myVars.msisdn = results.data.msisdn;
      ++cov_2p8b3j5xhg.s[12];
      myVars.checkMember = results.data.active;
      ++cov_2p8b3j5xhg.s[13];
      myVars.packageid = results.data.packageid;
    });
  });
}).config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  ++cov_2p8b3j5xhg.f[5];
  ++cov_2p8b3j5xhg.s[14];

  $locationProvider.html5Mode(true).hashPrefix('!');
  ++cov_2p8b3j5xhg.s[15];
  $urlRouterProvider.otherwise('/');

  ++cov_2p8b3j5xhg.s[16];
  $stateProvider.state('app', {
    url: '/',
    component: 'app'
  }).state('print', {
    url: '/print',
    component: 'print'
  }).state('account', {
    url: '/tai-khoan',
    component: 'account'
  }).state('xemhuongnha', {
    url: '/xem-huong-nha',
    component: 'xemhuongnha'
  }).state('xemhantamtai', {
    url: '/xem-han-tam-tai',
    component: 'xemhantamtai'
  }).state('xemngaycuoi', {
    url: '/xem-ngay-cuoi',
    component: 'xemngaycuoi'
  }).state('sinhcon', {
    url: '/sinh-con',
    component: 'sinhcon'
  }).state('xuathanh', {
    url: '/xuat-hanh',
    component: 'xuathanh'
  }).state('lichvannien', {
    url: '/lich-van-nien',
    component: 'lichvannien'
  }).state('clips', {
    url: '/video',
    component: 'clips'
  }).state('view', {
    url: '/view/:title/:clipid',
    component: 'views',
    resolve: {
      clipData: ['$rootScope', '$http', '$stateParams', 'myVars', function ($rootScope, $http, $stateParams, myVars) {
        ++cov_2p8b3j5xhg.f[6];

        var content = (++cov_2p8b3j5xhg.s[17], {
          msisdn: myVars.msisdn,
          id: $stateParams.clipid
        });
        var config = (++cov_2p8b3j5xhg.s[18], {
          params: content,
          headers: { Accept: 'application/json' }
        });
        ++cov_2p8b3j5xhg.s[19];
        return $http.get($rootScope.apiOpen + 'clips/find/' + $stateParams.clipid).then(function (results) {
          ++cov_2p8b3j5xhg.f[7];
          ++cov_2p8b3j5xhg.s[20];

          return results.data;
        });
      }]
    }
  }).state('tintic', {
    url: '/tin-tuc/:title/:categorieid',
    component: 'tintuc'
  }).state('ads', {
    url: '/pt19/:cpid/:mm/:packageid',
    component: 'ads'
  }).state('chitiet', {
    url: '/chi-tiet/:title/:articleid',
    component: 'chitiet'
  });
}